/* eslint-disable @typescript-eslint/no-var-requires */

const files = {
  // Mediakit
  ivaBrandGuideline: require('../files/iva-brand-guideline2401a.pdf'),
  fakebustersBrandGuideline: require('../files/fakebusters-brand-guideline2310a.pdf')
}

export default files
